import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import axios from 'utils/axios';
import { TaskProps } from 'types/props-obj/TaskProps';
const initialState: TaskProps = {
    apiEndPoint: "",
    isOpen: false,
    pageNumber:1,
    last_page:1,
    pageLimit:5,
    current_page:1,
    total:0,
    list: [],
    item:null,
    error: null,
    alertPopup: false
};
const projectTask = createSlice({
    name: 'projectTask',
    initialState,
    reducers: {



        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all projectTask list
        getList(state, action) {
            state.list.push(action.payload);
            const replaceList = state.list.filter((liste) => liste.id != 0);
            state.list = replaceList;
        },
        openToggle(state, action) {

            state.isOpen = action.payload.isOpen;
        },
        // get projectTask details
        setProjectTask(state, action) {
            state.item = action.payload;
        },

        // GET ProjectTasks
        setProjectTasksSuccess(state, action) {
            state.list = action.payload.data;
            state.current_page=action.payload.current_page;
            state.last_page=action.payload.last_page;
            state.total=action.payload.total
        },

        // ADD ProjectTask
        addProjectTaskSuccess(state, action) {
            state.list = [...state.list,action.payload];
        },

        // EDIT ProjectTask
        editProjectTaskSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id == action.payload.id);
            state.item= action.payload;
            state.list[foundIndex] = action.payload;
        },

        deleteProjectTaskSuccess(state, action) {
            const deleteData = state.list.filter((item) => item.id !== action.payload);
            state.list = deleteData;
        },

        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        }
    }
});
export default projectTask.reducer;
export const {    getList,setPageNumber,setPageLimit,alertPopupToggle,openToggle} = projectTask.actions;

export function getProjectTasks(params:any={},projectId:number) {
    return async () => {
        try {
            const response = await axios.get('project/'+projectId+'/task',{params:params});
            dispatch(projectTask.actions.setProjectTasksSuccess(response.data));
        } catch (error) {
            dispatch(projectTask.actions.hasError(error));
        }
    };
}

export function getProjectTask(id: number | undefined,projectId:number) {
    return async () => {
        try {
            const response = await axios.get('project/'+projectId+'/task/'+  id);
            dispatch(projectTask.actions.setProjectTask(response.data));
        } catch (error) {
            dispatch(projectTask.actions.hasError(error));
        }
    };
}

export function addProjectTask(ls:any,projectId:number) {
    return async () => {
        try {
            const response = await axios.post('project/'+projectId+'/task', ls);
            dispatch(projectTask.actions.addProjectTaskSuccess(response.data));
        } catch (error) {
            dispatch(projectTask.actions.hasError(error));
        }
    };
}

export function editProjectTask(id: number | undefined,ls: any,projectId:number) {
    return async () => {
        try {
            const response = await axios.put('project/'+projectId+'/task/'+id, ls);
            dispatch(projectTask.actions.editProjectTaskSuccess(response.data));
        } catch (error) {
            dispatch(projectTask.actions.hasError(error));
        }
    };
}

export function deleteProjectTask(id: number | undefined,projectId:number) {
    return async () => {
        try {
            await axios.delete('project/'+projectId+'/task/'+id);
            dispatch(projectTask.actions.deleteProjectTaskSuccess(id));
        } catch (error) {
            dispatch(projectTask.actions.hasError(error));
        }
    };
}